// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpCheckbox } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const Checkbox = wrap(jpCheckbox(), { events: { onChange: 'change' } });
// @ts-expect-error unknown property
Checkbox.displayName = 'Jupyter.Checkbox';
